import { useRef, useState } from 'react'
import { useSelector } from 'react-redux'

import useToggleHandler from 'hooks/useToggleHandler'
import {
    SECONDARY_DEVICE,
    VIDEO_CALL,
    WHITEBOARD,
} from 'services/webSockets/roomState/constants'
import { dispatchRoomState } from 'store/dispatcher'
import { _previousWhiteboard } from 'store/selectors/Artefacts'
import { _isStudent } from 'store/selectors/User'
import { _roomStateMsgData } from 'store/selectors/WebSocket'

export default function useWhiteboard({
    setWhiteboardMode,
    isWhiteboardMode,
    isArtefactMode,
}) {
    const previousWhiteboard = useSelector(_previousWhiteboard)
    const data = useSelector(_roomStateMsgData)

    const isStudent = useSelector(_isStudent)

    const popupRef = useRef()

    const {
        open: isWhiteboardModesListOpen,
        setOpen: setIsWhiteboardModesListOpen,
    } = useToggleHandler(popupRef)
    const [
        isConnectToTabletModalOpen,
        setIsConnectToTabletModalOpen,
    ] = useState(false)

    const toggleWhiteboardModesListOpen = () =>
        setIsWhiteboardModesListOpen(st => !st)

    const toggleConnectToTabletModalOpen = () =>
        setIsConnectToTabletModalOpen(st => !st)

    const isSecondaryDevice = data === SECONDARY_DEVICE
    const isWhiteboardOpen = isWhiteboardMode || isSecondaryDevice

    const isDisabled = (isArtefactMode && !isWhiteboardOpen) || isStudent

    const toggleModes = () => {
        if (!isWhiteboardMode) toggleWhiteboardModesListOpen()
        closeWhiteboard()
    }

    const startVideoCall = () => dispatchRoomState(VIDEO_CALL)
    const startWhiteboard = () => dispatchRoomState(WHITEBOARD)

    const whiteboardHandle = () => {
        setWhiteboardMode(!isWhiteboardMode)
        if (!isWhiteboardMode) {
            startWhiteboard()
        } else {
            startVideoCall()
        }
    }

    const closeWhiteboard = () => {
        if (isWhiteboardMode) {
            setWhiteboardMode(false)
            startVideoCall()
        }
    }

    const toggleWhiteboard = () => {
        if (isDisabled) return
        if (previousWhiteboard) whiteboardHandle()
        else toggleModes()
    }

    return {
        popupRef,
        isWhiteboardOpen,
        toggleWhiteboard,
        isDisabled,
        isWhiteboardModesListOpen,
        toggleWhiteboardModesListOpen,
        isConnectToTabletModalOpen,
        toggleConnectToTabletModalOpen,
    }
}
